module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"connectDomain":"Подключить свой домен","saveDomain":"Сохранить","savedDomain":"Домен сохранен","enterYourDomain":"*Введите свой домен","enterOurDomain":"*Введите домен","ifNotDomain":"Если вы не имеете своего домена, можете воспользоваться нашим","deleteDomain":"Отвязать домен","instructionsDomain":"Инструкция по подключению домена"}}')
  delete Component.options._Ctor
}
